import { render, staticRenderFns } from "./ShareModal.vue?vue&type=template&id=5cba8997&scoped=true&"
import script from "./ShareModal.vue?vue&type=script&lang=js&"
export * from "./ShareModal.vue?vue&type=script&lang=js&"
import style0 from "./ShareModal.vue?vue&type=style&index=0&id=5cba8997&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cba8997",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Modal: require('/app/appsumo/nuxt/components/common/Modal.vue').default})
